import { render, staticRenderFns } from "./ShareQrCode.vue?vue&type=template&id=4a2e8b4c&"
import script from "./ShareQrCode.vue?vue&type=script&lang=js&"
export * from "./ShareQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports